/**
 * Given a user id and a percentage from 0 to 1,
 * compute whether the user id is above or below a percentage threshold,
 * determined by the last two digits of the user id.
 *
 * This is useful for splitting users into groups for rolling out features in a controlled way.
 *
 * @method isUserIdInPercentageThreshold
 * @param {number} userId
 * @param {number} percentage
 * @returns {boolean}
 */
const isUserIdInPercentageThreshold = (userId, percentage) => {
  return Number(userId) % 100 <= Math.floor(percentage * 100);
};

export default isUserIdInPercentageThreshold;
